
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'Agreement',
})
export default class Agreement extends Vue {}
